module.exports = __webpack_public_path__ + "static/media/icn_awaiting_period_myway.077f8104.svg";